import { DashboardSavedsearchReportsFiltersModels } from './../../../../models/dashboard-savedsearch-reports/dashboard-savedsearch-reports-filter.models';
import { DashboardSavedsearchReportsModels } from './dashboardSavedsearchReportsData.state';

export function getDashboardSavedsearchReportsdData(dashboardSavedsearchReports: DashboardSavedsearchReportsModels[], reportType: string, addedFilters: DashboardSavedsearchReportsFiltersModels) {

    let results: { data: DashboardSavedsearchReportsModels | null, index: number } = {
        data: null,
        index: -1
    }

    const index = dashboardSavedsearchReports.findIndex(data => data.reportType == reportType &&
        data.addedFilters.savedSearchId == addedFilters.savedSearchId &&
        data.addedFilters.query == addedFilters.query);

    if (index > -1) {
        results.data = dashboardSavedsearchReports[index];
        results.index = index;
    }

    return results;

}
